import { toast } from "react-toastify";
import { apiURL } from "../../config";

export async function getMattersList(axiosPrivate, unitId, searchPhrase) {
	return axiosPrivate
		.get(`${apiURL}/matters/list.json?unitId=${unitId}${searchPhrase && searchPhrase !== "" ? "&phrase=" + searchPhrase : ""}`)
		.then((res) => {
			if (res.status < 300 && res.status > 199) return res.data;
		})
		.catch((err) => {
			return err.response;
		});
}

export async function deleteMatter(axiosPrivate, cb, matterId) {
	return axiosPrivate
		.delete(`${apiURL}/matter/${matterId}.json`)
		.then((res) => {
			if (res.status > 199 && res.status < 300) {
				toast.success("Matter - deleted");
				cb();
			} else {
				toast.error("Matter failed to be deleted");
			}
		})
		.catch((err) => {
			return err.response;
		});
}

export async function editMatter(axiosPrivate, cb, matterId, data) {
	return axiosPrivate
		.put(`${apiURL}/matter/${matterId}.json`, data)
		.then((res) => {
			if (res.status > 199 && res.status < 300) {
				toast.success("Matter - updated");
				cb();
			} else {
				toast.error("Matter failed to update");
			}
		})
		.catch((err) => {
			return err.response;
		});
}
export async function addMatter(axiosPrivate, cb, data) {
	return axiosPrivate
		.post(`${apiURL}/matters.json`, data)
		.then((res) => {
			if (res.status > 199 && res.status < 300) {
				toast.success("Matter - updated");
				cb();
			} else {
				toast.error("Matter failed to update");
			}
		})
		.catch((err) => {
			return err.response;
		});
}

export async function reorderMatters(axiosPrivate, orderData) {
	return axiosPrivate.put("/matters/reorder.json", orderData);
}
